import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';

export function RowActions({ children }: PropsWithChildren<unknown>) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1.5,
        flexWrap: 'nowrap',
      }}
    >
      {children}
    </Box>
  );
}
